import { AddCircle } from "@mui/icons-material";
import { Stack } from "@mui/material";
import CustomText from "components/typography/CustomText";
import React from "react";
import PieCard from "./PieCard";

export default function PieAddCard({
  disabled = false,
  onClick = () => {},
  data = {},
  pieIndex = 0,
}) {
  return (
    <div
      id={`flavour-${pieIndex}`}
      onClick={onClick}
      className={`transition-all duration-300 ${
        disabled
          ? "pointer-events-none opacity-50"
          : "cursor-pointer shadow-logo"
      } w-full h-full border rounded ${
        data?.isEmpty
          ? "border-dashed border-bright-gray"
          : "border-transparent"
      } overflow-hidden relative`}
    >
      {data?.isEmpty ? (
        <Stack
          spacing={2}
          justifyContent="center"
          alignItems="center"
          className="h-full"
        >
          <AddCircle />
          <CustomText variant="body2" bold={600}>
            {disabled ? "Adding a Pie" : "Add a Flavour"}
          </CustomText>
        </Stack>
      ) : (
        <div className="relative w-full h-full">
          <div className="relative h-full w-full flex flex-col items-stretch">
            <div
              className="
              relative pointer-events-none
              flex-grow flex justify-center
              rounded overflow-hidden"
            >
              <PieCard dense data={data?.data ?? {}} />
            </div>
            <div className="rounded">
              <CustomText
                font="zing"
                align="center"
                variant="h5"
                color="secondary"
              >
                {data?.data?.name ?? ""}
              </CustomText>
            </div>
            <div className="py-2 rounded overflow-hidden cursor-pointer">
              <CustomText
                variant="body2"
                bold={600}
                align="center"
                color="primary"
              >
                Change
              </CustomText>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
